// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/interview-theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   OTP VERIFICATION SCREEN - G42 BRANDING
   ========================================== */

.otp-container {
  min-height: 100vh;
  background: var(--interview-bg-main);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--interview-space-3xl) var(--interview-space-lg);
  font-family: var(--interview-font-primary);
}

.otp-heading {
  font-size: 1.4375rem;
  font-weight: var(--interview-text-bold);
  color: var(--interview-text-primary);
  margin: 0 0 7px 0;
  text-align: center;
  line-height: 1.3;
  letter-spacing: 0;
}

.otp-subheading {
  font-size: 0.875rem;
  color: var(--interview-text-muted);
  margin: 0 0 16px 0;
  text-align: center;
  line-height: 1.6;
  font-weight: var(--interview-text-regular);
}

.otp-emailBadge {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background-color: var(--interview-success-lighter);
  border: 1px solid var(--interview-success-border);
  padding: 7px 15px;
  border-radius: 20px;
  font-size: var(--interview-text-sm);
  color: var(--interview-success-dark);
  margin-bottom: 20px;
  font-weight: var(--interview-text-semibold);
}

.otp-otpContainer {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin: 8px 0 20px;
  max-width: 100%;
  flex-wrap: nowrap;
}

.otp-otpInput {
  width: 54px;
  height: 62px;
  min-width: 54px;
  max-width: 54px;
  border: 1.5px solid var(--interview-border-default);
  border-radius: var(--interview-radius-xl);
  font-size: 1.625rem;
  font-weight: var(--interview-text-bold);
  text-align: center;
  background-color: var(--interview-bg-white);
  transition: all var(--interview-transition-base);
  color: var(--interview-text-primary);
  box-sizing: border-box;
  flex-shrink: 0;
  font-family: var(--interview-font-primary);
}

.otp-otpInput:focus {
  outline: none;
  border-color: var(--interview-brand-primary);
  background-color: var(--interview-success-light);
  box-shadow: var(--interview-shadow-focus);
}

.otp-otpInput.otp-filled {
  border-color: var(--interview-brand-primary);
  background-color: var(--interview-success-light);
}

.otp-timer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-bottom: 16px;
  font-size: var(--interview-text-sm);
  color: var(--interview-warning);
  font-weight: var(--interview-text-semibold);
}

.otp-timerIcon {
  font-size: 0.875rem;
}

.otp-resendSection {
  text-align: center;
  font-size: var(--interview-text-sm);
  color: var(--interview-text-muted);
  margin-top: 16px;
  line-height: 1.6;
}

.otp-resendLink {
  color: var(--interview-brand-primary);
  text-decoration: underline;
  font-weight: var(--interview-text-medium);
  cursor: pointer;
  transition: color var(--interview-transition-base);
}

.otp-resendLink:hover {
  color: var(--interview-brand-primary-dark);
}

.otp-resendLink.otp-disabled {
  color: var(--interview-text-disabled);
  cursor: not-allowed;
  text-decoration: none;
}

.otp-errorMessage {
  background-color: var(--interview-error-light);
  color: var(--interview-error-dark);
  padding: var(--interview-space-md) var(--interview-space-lg);
  border-radius: var(--interview-radius-md);
  font-size: 0.875rem;
  margin-bottom: var(--interview-space-lg);
  text-align: center;
  line-height: 1.6;
  font-weight: var(--interview-text-medium);
}

.otp-successMessage {
  background-color: var(--interview-success-light);
  color: var(--interview-success-dark);
  padding: var(--interview-space-md) var(--interview-space-lg);
  border-radius: var(--interview-radius-md);
  font-size: 0.875rem;
  margin-bottom: var(--interview-space-lg);
  text-align: center;
  line-height: 1.6;
  font-weight: var(--interview-text-medium);
}

@media (max-width: 576px) {
  .otp-heading {
    font-size: var(--interview-text-xl);
  }

  .otp-otpInput {
    width: 44px;
    height: 44px;
    font-size: 1.25rem;
  }

  .otp-otpContainer {
    gap: var(--interview-space-sm);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Interview/OTPVerification/OTPVerification.css"],"names":[],"mappings":"AAAA;;+CAE+C;;AAI/C;EACE,iBAAiB;EACjB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,uCAAuC;EACvC,oCAAoC;EACpC,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kDAAkD;EAClD,iDAAiD;EACjD,iBAAiB;EACjB,mBAAmB;EACnB,mCAAmC;EACnC,oCAAoC;EACpC,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,mDAAmD;EACnD,yCAAyC;EACzC,mBAAmB;EACnB,uCAAuC;EACvC,kBAAkB;EAClB,2CAA2C;EAC3C,gDAAgD;EAChD,oCAAoC;EACpC,sBAAsB;EACtB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,gDAAgD;EAChD,yCAAyC;AAC3C;;AAEA;EACE,4CAA4C;EAC5C,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,mCAAmC;EACnC,+BAA+B;EAC/B,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,yCAAyC;EACzC,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,8CAA8C;EAC9C,kCAAkC;EAClC,4DAA4D;EAC5D,yCAAyC;EACzC,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,gDAAgD;EAChD,oCAAoC;EACpC,4DAA4D;EAC5D,yCAAyC;EACzC,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE;IACE,mCAAmC;EACrC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,8BAA8B;EAChC;AACF","sourcesContent":["/* ==========================================\n   OTP VERIFICATION SCREEN - G42 BRANDING\n   ========================================== */\n\n@import '../../../styles/interview-theme.css';\n\n.otp-container {\n  min-height: 100vh;\n  background: var(--interview-bg-main);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--interview-space-3xl) var(--interview-space-lg);\n  font-family: var(--interview-font-primary);\n}\n\n.otp-heading {\n  font-size: 1.4375rem;\n  font-weight: var(--interview-text-bold);\n  color: var(--interview-text-primary);\n  margin: 0 0 7px 0;\n  text-align: center;\n  line-height: 1.3;\n  letter-spacing: 0;\n}\n\n.otp-subheading {\n  font-size: 0.875rem;\n  color: var(--interview-text-muted);\n  margin: 0 0 16px 0;\n  text-align: center;\n  line-height: 1.6;\n  font-weight: var(--interview-text-regular);\n}\n\n.otp-emailBadge {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  background-color: var(--interview-success-lighter);\n  border: 1px solid var(--interview-success-border);\n  padding: 7px 15px;\n  border-radius: 20px;\n  font-size: var(--interview-text-sm);\n  color: var(--interview-success-dark);\n  margin-bottom: 20px;\n  font-weight: var(--interview-text-semibold);\n}\n\n.otp-otpContainer {\n  display: flex;\n  gap: 10px;\n  justify-content: center;\n  margin: 8px 0 20px;\n  max-width: 100%;\n  flex-wrap: nowrap;\n}\n\n.otp-otpInput {\n  width: 54px;\n  height: 62px;\n  min-width: 54px;\n  max-width: 54px;\n  border: 1.5px solid var(--interview-border-default);\n  border-radius: var(--interview-radius-xl);\n  font-size: 1.625rem;\n  font-weight: var(--interview-text-bold);\n  text-align: center;\n  background-color: var(--interview-bg-white);\n  transition: all var(--interview-transition-base);\n  color: var(--interview-text-primary);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  font-family: var(--interview-font-primary);\n}\n\n.otp-otpInput:focus {\n  outline: none;\n  border-color: var(--interview-brand-primary);\n  background-color: var(--interview-success-light);\n  box-shadow: var(--interview-shadow-focus);\n}\n\n.otp-otpInput.otp-filled {\n  border-color: var(--interview-brand-primary);\n  background-color: var(--interview-success-light);\n}\n\n.otp-timer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  margin-bottom: 16px;\n  font-size: var(--interview-text-sm);\n  color: var(--interview-warning);\n  font-weight: var(--interview-text-semibold);\n}\n\n.otp-timerIcon {\n  font-size: 0.875rem;\n}\n\n.otp-resendSection {\n  text-align: center;\n  font-size: var(--interview-text-sm);\n  color: var(--interview-text-muted);\n  margin-top: 16px;\n  line-height: 1.6;\n}\n\n.otp-resendLink {\n  color: var(--interview-brand-primary);\n  text-decoration: underline;\n  font-weight: var(--interview-text-medium);\n  cursor: pointer;\n  transition: color var(--interview-transition-base);\n}\n\n.otp-resendLink:hover {\n  color: var(--interview-brand-primary-dark);\n}\n\n.otp-resendLink.otp-disabled {\n  color: var(--interview-text-disabled);\n  cursor: not-allowed;\n  text-decoration: none;\n}\n\n.otp-errorMessage {\n  background-color: var(--interview-error-light);\n  color: var(--interview-error-dark);\n  padding: var(--interview-space-md) var(--interview-space-lg);\n  border-radius: var(--interview-radius-md);\n  font-size: 0.875rem;\n  margin-bottom: var(--interview-space-lg);\n  text-align: center;\n  line-height: 1.6;\n  font-weight: var(--interview-text-medium);\n}\n\n.otp-successMessage {\n  background-color: var(--interview-success-light);\n  color: var(--interview-success-dark);\n  padding: var(--interview-space-md) var(--interview-space-lg);\n  border-radius: var(--interview-radius-md);\n  font-size: 0.875rem;\n  margin-bottom: var(--interview-space-lg);\n  text-align: center;\n  line-height: 1.6;\n  font-weight: var(--interview-text-medium);\n}\n\n@media (max-width: 576px) {\n  .otp-heading {\n    font-size: var(--interview-text-xl);\n  }\n\n  .otp-otpInput {\n    width: 44px;\n    height: 44px;\n    font-size: 1.25rem;\n  }\n\n  .otp-otpContainer {\n    gap: var(--interview-space-sm);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
